import { useDispatch } from 'react-redux';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { deletePlace, patchFavorite } from './placesSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

library.add(fas, far);

const PlaceCard = ({ place, detailPath, placeholder }) => {
    const dispatch = useDispatch();
    const { id, imageUrl, title, description, location, favorite } = place;

    const imageSrc = imageUrl || placeholder;

    return (
        <Card className='h-100'>
            <Card.Img
                variant='top'
                alt={title}
                src={imageSrc}
            />
            <Card.Body className='d-flex flex-column'>
                <Card.Title>{title}</Card.Title>
                <Card.Subtitle className='mb-2 text-muted'>
                    {location?.name}
                </Card.Subtitle>
                <Card.Text>{description}</Card.Text>
                <div className='d-flex align-items-center mt-auto'>
                    <Link to={`${detailPath}/${id}`}>
                        <Button>Details</Button>
                    </Link>
                    <div className='d-flex align-items-center ms-auto'>
                        <FontAwesomeIcon
                            onClick={() => dispatch(patchFavorite({ placeId: id, favorite: !favorite }))}
                            icon={favorite ? 'fa-solid fa-heart' : 'fa-regular fa-heart'}
                            size='xl'
                            color='red'
                            style={{ cursor: 'pointer' }}
                        />
                        <FontAwesomeIcon
                            data-testid='delete-place-btn'
                            icon='fa-solid fa-trash-can'
                            size='xl'
                            style={{ cursor: 'pointer' }}
                            onClick={() => dispatch(deletePlace(id))}
                        />
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default PlaceCard;